var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        {
          attrs: {
            flat: "",
            color: "primary",
            role: "heading",
            "aria-level": "1",
            "aria-label": _vm.$t("components.transactions.title"),
          },
        },
        [
          _c("v-toolbar-title", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("components.transactions.title")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.transactionsFormatted,
              loading: _vm.isLoading,
              "items-per-page": 15,
              "loading-text": "Loading... Please wait",
              "no-results-text": "No transactions were found",
              "no-data-text": "No data was found",
              "item-key": "orderId",
              "sort-by": "created",
              "group-desc": "",
              color: "secondary",
              "aria-live": "polite",
              "aria-busy": _vm.isLoading,
              "aria-label": _vm.$t("components.transactions.title"),
              "footer-props": {
                showFirstLastPage: true,
                firstIcon: "fad fa-chevron-double-left",
                lastIcon: "fad fa-chevron-double-right",
                prevIcon: "fad fa-chevron-left",
                nextIcon: "fad fa-chevron-right",
              },
            },
            scopedSlots: _vm._u([
              {
                key: "progress",
                fn: function () {
                  return [
                    _c("v-progress-linear", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isLoading,
                          expression: "isLoading",
                        },
                      ],
                      attrs: {
                        color: "accent",
                        indeterminate: "",
                        "aria-hidden": "true",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "body",
                fn: function (ref) {
                  var items = ref.items
                  return [
                    _c(
                      "tbody",
                      _vm._l(items, function (item) {
                        return _c("tr", { key: item.orderId }, [
                          _c("td", [_vm._v(_vm._s(item.orderId || "0"))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(item.transactionId || "No transaction ID")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.price || 0))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.points || 0))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(item.provider || "Unknown")),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.status || "Failed"))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.created || "Unknown"))]),
                          _vm._v(" "),
                          _c("td", [
                            item.pdfLink
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link-accent",
                                    attrs: {
                                      href: item.pdfLink,
                                      target: "_blank",
                                      rel: "noopener",
                                      role: "link",
                                      "aria-label":
                                        _vm.$t(
                                          "components.transactions.download"
                                        ) +
                                        " - " +
                                        item.orderId,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.transactions.download"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "text-body-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.transactions.unavailable"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }